import { useState } from "react";
import { CreditCard } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";

export const PlanCheckoutButton = ({ companyId, companyName, plans, paid, testId }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState("");

  const pay = async (lookup_key) => {
    setBusy(lookup_key);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key,
        company_id: companyId,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(errMsg(err));
      setBusy("");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          data-testid={`${testId}-open`}
          className="rounded-full border-slate-300 transition-colors duration-200 hover:bg-slate-100"
        >
          <CreditCard className="mr-1.5 h-3.5 w-3.5" /> {paid ? "Change plan" : "Choose plan & pay"}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-extrabold tracking-tight">
            Subscription for {companyName}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3" data-testid={`${testId}-plans`}>
          {plans.map((p) => (
            <button
              key={p.lookup_key}
              type="button"
              disabled={!!busy}
              onClick={() => pay(p.lookup_key)}
              data-testid={`${testId}-plan-${p.lookup_key}`}
              className="flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white p-5 text-left transition-colors duration-200 hover:border-blue-500 hover:bg-blue-50/40 disabled:opacity-60"
            >
              <div>
                <div className="font-display text-base font-bold text-slate-900">{p.name}</div>
                <div className="mt-0.5 text-sm text-slate-500">{p.blurb}</div>
              </div>
              <div className="shrink-0 pl-4 text-right">
                <div className="font-display text-xl font-black text-slate-900">{p.price}</div>
                <div className="text-[11px] uppercase tracking-[0.16em] text-slate-500">
                  per {p.interval}
                </div>
              </div>
            </button>
          ))}
          <p className="pt-1 text-center text-xs text-slate-500">
            Prices are plus tax when applicable · Secure checkout by Stripe · test card 4242 4242
            4242 4242
            <br />* - Archived credit applications may be purged by the subscribing company as
            needed
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
